import { useContext } from 'react';

// auth provider
import { NotificationContext } from 'contexts/NotificationContext';

// ==============================|| AUTH HOOKS ||============================== //

const useNotificationContext = () => {
    const context = useContext(NotificationContext);

    if (!context) throw new Error('context must be use inside provider');

    return context;
};

export default useNotificationContext;
